'use strict'

export default
{
	"rootFolder": "",
    "assets": "http://192.168.33.66/uploads/"
} 
